// Subí este número a mano antes de cada export/subida al hosting.
export const APP_VERSION = "1.2";
